import { computed } from 'vue';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import PasswordInputBaseV2 from '../PasswordInputBase/PasswordInputBaseV2.class';

export default class PasswordInput extends PasswordInputBaseV2 {
	public validation: boolean;

	public showPasswordError = computed((): boolean => {
		return this.store.getters.showPasswordError();
	});

	public isValidPassword = computed((): boolean => {
		return this.store.getters.isValidPassword();
	});

	constructor(store: IIncentiveV2Store, validation = false) {
		super(store);
		this.validation = validation;
	}

	public savePassword(): void {
		this.store.actions.savePassword(this.inputText.value);
	}
}
